import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, Stack, styled, Typography } from '@mui/material';
import moment from 'moment';
import { Box } from '@mui/system';
import Label from '../../../components/Label';
import Iconify from '../../../fl-components/Iconify';

const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2)
}));

const TypographyStyle = styled(Typography)(() => ({
  fontSize: '17px',
  textTransform: 'capitalize'
}));

const DetailContainer = styled('div')({
  marginTop: '15px'
});

const StyledStack = styled(Stack)(() => ({
  marginTop: '5px'
}));

export default function CalendarEventDialog({ open, handleClose, event }) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogContent>
        <Label
          color={event?.type === 'event' ? 'success' : 'warning'}
          sx={{ textTransform: 'uppercase', position: 'absolute', top: 24, right: 24 }}
        >
          {event?.type}
        </Label>
        <Stack direction="row" alignItems="center">
          <Box
            sx={{
              background: event?.textColor,
              height: 20,
              width: 20,
              borderRadius: '4px',
              marginRight: '16px'
            }}
          />
          <Typography variant="h4">{event?.title}</Typography>
        </Stack>
        <DetailContainer>
          {event?.description && (
            <StyledStack direction="row" alignItems="start">
              <IconStyle icon="fluent:text-description-20-filled" />
              <TypographyStyle>{event?.description}</TypographyStyle>
            </StyledStack>
          )}
          <StyledStack direction="row" alignItems="center">
            <IconStyle icon="ic:baseline-event" />
            <TypographyStyle>
              {moment(event?.startDate).format('DD MMM YYYY, LT ')}
              <span>-</span>
              {moment(event?.endDate).format(' DD MMM YYYY, LT')}
            </TypographyStyle>
          </StyledStack>
        </DetailContainer>
      </DialogContent>
    </Dialog>
  );
}

CalendarEventDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  event: PropTypes.object
};
